import {SharedIssueBaseActions} from "@shared/components/issues/store/shared-issue-base.action-type";

export {SharedIssueBaseActions as TeamIssuesActions};
